export const generateYearOptions = (minYear, maxYear) => {
  const years = [];
  for (let i = maxYear; i >= minYear; i--) {
    years.push({ value: i?.toString(), label: i });
  }
  return years;
};
